import { motion, useScroll, useSpring } from "framer-motion";

// Measuring-tape scroll progress, pinned under the top edge.
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.3 });
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-[3px] pointer-events-none" aria-hidden="true" data-testid="scroll-progress">
      <motion.div className="tape h-full origin-left" style={{ scaleX }} />
    </div>
  );
};
